import React from "react";
import { Flex, Text, Input } from "@chakra-ui/react";
import Heading from "../Text/heading";

const smallUppercaseWithletterSpace = {
  fontWeight: "800",
  fontSize: "8px",
  lineHeight: "16px",
  color: "#0E3665",
  fontFamily: "Nunito",
  textTransform: "uppercase",
  letterSpacing: "2px",
};

const inputTextStyle = {
  width: "100%",
  height: "38px",
  border: "1px solid #ECEFF9",
  borderRadius: "4px",
  fontWeight: "700",
  fontSize: "13px",
  lineHeight: "22px",
  color: "#0E3665",
  fontFamily: "Nunito",
  marginTop: "8px",
  backgroundColor: "#D9D9D933",
};

const Form = ({
  formData,
  errors,
  handleFormChange,
  disabled,
  updateBooking,
}) => {
  return (
    <Flex flexDirection={"column"} width={"92.92%"} minheight={"330px"}>
      {updateBooking ? null : <Heading headingLabel="Booking Appointment" />}
      <Text {...smallUppercaseWithletterSpace} marginTop={"40px"}>
        First Name
      </Text>
      <Input
        {...inputTextStyle}
        name="customerFirstName"
        value={formData.customerFirstName}
        onChange={handleFormChange}
        disabled={disabled}
      />
      {errors?.customerFirstName && (
        <Text color="red" mt="1" fontSize="12">
          {errors?.customerFirstName}
        </Text>
      )}
      <Text {...smallUppercaseWithletterSpace} marginTop={"16px"}>
        Last Name
      </Text>
      <Input
        {...inputTextStyle}
        name="customerLastName"
        value={formData.customerLastName}
        onChange={handleFormChange}
        disabled={disabled}
      />
      {errors?.customerLastName && (
        <Text color="red" mt="1" fontSize="12">
          {errors?.customerLastName}
        </Text>
      )}
      <Text {...smallUppercaseWithletterSpace} marginTop={"16px"}>
        Phone Number
      </Text>
      <Input
        {...inputTextStyle}
        name="phoneNumber"
        value={formData.phoneNumber}
        onChange={handleFormChange}
        disabled={disabled}
      />
      {errors?.phoneNumber && (
        <Text color="red" mt="1" fontSize="12">
          {errors?.phoneNumber}
        </Text>
      )}
      <Text {...smallUppercaseWithletterSpace} marginTop={"16px"}>
        Reference Number
      </Text>
      <Input
        {...inputTextStyle}
        value={formData.customerId}
        name="customerId"
        onChange={handleFormChange}
        disabled={disabled}
      />
      {errors?.customerId && (
        <Text color="red" mt="1" fontSize="12">
          {errors?.customerId}
        </Text>
      )}
    </Flex>
  );
};

export default Form;
